import { render, staticRenderFns } from "./RegistrationsTable.vue?vue&type=template&id=50aa3da4&scoped=true&"
import script from "./RegistrationsTable.vue?vue&type=script&setup=true&lang=ts&"
export * from "./RegistrationsTable.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./RegistrationsTable.vue?vue&type=style&index=0&id=50aa3da4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50aa3da4",
  null
  
)

export default component.exports